/* Homepage hero winter/Christmas layer (live since 2026-10-06, loaded from layout/theme.liquid; does nothing on pages without the hero).
   Light falling snow on a canvas, a few soft bokeh orbs and a snowy ground, all BEHIND the phone, cards and copy.
   Pauses off-screen and in hidden tabs; static under prefers-reduced-motion. */
(function () {
  var hero = document.querySelector('[id^="LgPh-"].lgph');
  if (!hero || hero.querySelector('.lgban-fx')) return;
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fx = document.createElement('div');
  fx.className = 'lgban-fx'; fx.setAttribute('aria-hidden', 'true');
  var orbs = '';
  var O = [[8, 22, 120, 'w'], [86, 16, 90, 'b'], [18, 70, 70, 'g'], [78, 64, 130, 'w'], [52, 12, 60, 'b'], [34, 40, 46, 'w'], [66, 36, 54, 'g'], [93, 48, 40, 'w'], [4, 52, 56, 'b'], [46, 80, 80, 'w']];
  for (var i = 0; i < O.length; i++) {
    orbs += '<i class="lgban-orb lgban-orb--' + O[i][3] + '" style="left:' + O[i][0] + '%;top:' + O[i][1] + '%;width:' + O[i][2] + 'px;height:' + O[i][2] + 'px;--d:' + (9 + i * 1.7).toFixed(1) + 's;--dl:-' + (i * 1.3).toFixed(1) + 's"></i>';
  }
  fx.innerHTML = orbs + '<canvas class="lgban-snow"></canvas><div class="lgban-ground"></div>';
  hero.insertBefore(fx, hero.firstChild);


  /* ---- code-drawn decor: bright gold stars, snowy pine branches with berries + baubles, wrapped gifts ---- */
  var seed = 7; function rnd() { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }
  var NS = 'http://www.w3.org/2000/svg';
  function star(cls) {
    var pts = [], i, a, r;
    for (i = 0; i < 10; i++) { a = -Math.PI / 2 + i * Math.PI / 5; r = i % 2 ? 19 : 46; pts.push([50 + r * Math.cos(a), 50 + r * Math.sin(a)]); }
    var facets = '';
    for (i = 0; i < 10; i++) {
      var p1 = pts[i], p2 = pts[(i + 1) % 10];
      facets += '<path d="M50 50L' + p1[0].toFixed(1) + ' ' + p1[1].toFixed(1) + 'L' + p2[0].toFixed(1) + ' ' + p2[1].toFixed(1) + 'Z" fill="url(#lgbS' + (i % 2 ? 'b' : 'a') + ')"/>';
    }
    return '<svg class="lgban-star ' + cls + '" viewBox="0 0 100 100" aria-hidden="true"><defs>' +
      '<linearGradient id="lgbSa" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#FFF6CF"/><stop offset=".45" stop-color="#F5CC5A"/><stop offset="1" stop-color="#C08A2C"/></linearGradient>' +
      '<linearGradient id="lgbSb" x1="1" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#E9B444"/><stop offset=".6" stop-color="#B57B22"/><stop offset="1" stop-color="#8A5A14"/></linearGradient>' +
      '</defs>' + facets + '<circle cx="42" cy="36" r="5" fill="#FFFDF2" opacity=".85"/></svg>';
  }
  function twinkle(cls) { return '<svg class="lgban-tw ' + cls + '" viewBox="0 0 40 40" aria-hidden="true"><path d="M20 0C21.5 14 26 18.5 40 20C26 21.5 21.5 26 20 40C18.5 26 14 21.5 0 20C14 18.5 18.5 14 20 0Z" fill="#FFF3C4"/></svg>'; }
  function branch(flip) {
    seed = flip ? 19 : 7;
    var g = '', i, t, x, y, k;
    var greens = ['#1F4A33', '#2C6342', '#3B7A52', '#24563A', '#4C8A60'];
    /* main twig along a gentle curve from the corner */
    function P(t) { var x0 = 0, y0 = 10, x1 = 120, y1 = 40, x2 = 230, y2 = 115; return [(1 - t) * (1 - t) * x0 + 2 * (1 - t) * t * x1 + t * t * x2, (1 - t) * (1 - t) * y0 + 2 * (1 - t) * t * y1 + t * t * y2]; }
    var tw = ''; for (i = 0; i <= 20; i++) { var q = P(i / 20); tw += (i ? 'L' : 'M') + q[0].toFixed(1) + ' ' + q[1].toFixed(1); }
    g += '<path d="' + tw + '" stroke="#5B3A22" stroke-width="5" fill="none" stroke-linecap="round"/>';
    /* needles: short strokes fanning out on both sides of the twig */
    for (i = 0; i < 230; i++) {
      t = rnd(); var q2 = P(t); var side = rnd() < .5 ? -1 : 1; var ang = (Math.atan2(75, 230) + side * (0.7 + rnd() * 0.9));
      var len = 18 + rnd() * 26; x = q2[0] + Math.cos(ang) * len; y = q2[1] + Math.sin(ang) * len;
      g += '<path d="M' + q2[0].toFixed(1) + ' ' + q2[1].toFixed(1) + 'L' + x.toFixed(1) + ' ' + y.toFixed(1) + '" stroke="' + greens[(rnd() * greens.length) | 0] + '" stroke-width="' + (1.6 + rnd() * 1.4).toFixed(1) + '" stroke-linecap="round"/>';
    }
    /* snow dusting on top */
    for (i = 0; i < 26; i++) { t = rnd(); var q3 = P(t); g += '<ellipse cx="' + (q3[0] + (rnd() - .5) * 26).toFixed(1) + '" cy="' + (q3[1] - 8 - rnd() * 10).toFixed(1) + '" rx="' + (5 + rnd() * 8).toFixed(1) + '" ry="' + (2.5 + rnd() * 3).toFixed(1) + '" fill="#FFFFFF" opacity="' + (.75 + rnd() * .25).toFixed(2) + '"/>'; }
    /* red berry clusters */
    var berries = [.28, .52, .78];
    for (k = 0; k < berries.length; k++) {
      var b = P(berries[k]);
      for (i = 0; i < 4; i++) { var bx = b[0] + (rnd() - .5) * 16, by = b[1] + 10 + (rnd() - .5) * 12; g += '<circle cx="' + bx.toFixed(1) + '" cy="' + by.toFixed(1) + '" r="5.2" fill="url(#lgbBerry)"/><circle cx="' + (bx - 1.6).toFixed(1) + '" cy="' + (by - 1.8).toFixed(1) + '" r="1.5" fill="#fff" opacity=".8"/>'; }
    }
    /* one hanging glossy red bauble */
    var h = P(.62);
    g += '<path d="M' + h[0].toFixed(1) + ' ' + (h[1] + 6).toFixed(1) + 'V' + (h[1] + 44).toFixed(1) + '" stroke="#D9B45A" stroke-width="1.4"/>' +
      '<rect x="' + (h[0] - 6).toFixed(1) + '" y="' + (h[1] + 42).toFixed(1) + '" width="12" height="8" rx="2" fill="url(#lgbGold)"/>' +
      '<circle cx="' + h[0].toFixed(1) + '" cy="' + (h[1] + 72).toFixed(1) + '" r="23" fill="url(#lgbBall)"/>' +
      '<ellipse cx="' + (h[0] - 8).toFixed(1) + '" cy="' + (h[1] + 62).toFixed(1) + '" rx="7" ry="4.5" fill="#fff" opacity=".7" transform="rotate(-30 ' + (h[0] - 8).toFixed(1) + ' ' + (h[1] + 62).toFixed(1) + ')"/>';
    return '<svg class="lgban-branch' + (flip ? ' lgban-branch--r' : '') + '" viewBox="0 0 260 200" aria-hidden="true"><defs>' +
      '<radialGradient id="lgbBerry" cx=".35" cy=".35" r=".7"><stop offset="0" stop-color="#F0444C"/><stop offset="1" stop-color="#8E0F17"/></radialGradient>' +
      '<radialGradient id="lgbBall" cx=".35" cy=".3" r=".75"><stop offset="0" stop-color="#F2545B"/><stop offset=".55" stop-color="#C0141F"/><stop offset="1" stop-color="#6E0710"/></radialGradient>' +
      '<linearGradient id="lgbGold" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#FFF0B8"/><stop offset=".5" stop-color="#E2B04A"/><stop offset="1" stop-color="#9C6A1C"/></linearGradient>' +
      '</defs>' + g + '</svg>';
  }
  function gift(w, h, d, base, dark, top, ribbon) {
    /* simple 3/4 box: front face, side face, lid, gold ribbon and bow */
    var W = w + d + 6, H = h + d + 40;
    var fx0 = 3, fy0 = 40 + d;
    var s = '<svg class="lgban-gift" viewBox="0 0 ' + W + ' ' + H + '" width="' + W + '" height="' + H + '" aria-hidden="true">';
    s += '<path d="M' + fx0 + ' ' + fy0 + 'h' + w + 'v' + h + 'h-' + w + 'Z" fill="' + base + '"/>';
    s += '<path d="M' + (fx0 + w) + ' ' + fy0 + 'l' + d + ' -' + d + 'v' + h + 'l-' + d + ' ' + d + 'Z" fill="' + dark + '"/>';
    s += '<path d="M' + fx0 + ' ' + fy0 + 'l' + d + ' -' + d + 'h' + w + 'l-' + d + ' ' + d + 'Z" fill="' + top + '"/>';
    var rx = fx0 + w / 2 - 6;
    s += '<rect x="' + rx + '" y="' + fy0 + '" width="12" height="' + h + '" fill="url(#lgbRib)"/>';
    s += '<path d="M' + rx + ' ' + fy0 + 'l' + d + ' -' + d + 'h12l-' + d + ' ' + d + 'Z" fill="#F7D774"/>';
    s += '<path d="M' + (fx0 + w) + ' ' + (fy0 + h / 2 - 6) + 'l' + d + ' -' + d + 'v12l-' + d + ' ' + d + 'Z" fill="#C9962E"/>';
    var bx = fx0 + w / 2 + d / 2, by = fy0 - d / 2;
    s += '<ellipse cx="' + (bx - 13) + '" cy="' + (by - 9) + '" rx="15" ry="9" fill="' + ribbon + '" transform="rotate(-22 ' + (bx - 13) + ' ' + (by - 9) + ')"/>';
    s += '<ellipse cx="' + (bx + 13) + '" cy="' + (by - 9) + '" rx="15" ry="9" fill="' + ribbon + '" transform="rotate(22 ' + (bx + 13) + ' ' + (by - 9) + ')"/>';
    s += '<circle cx="' + bx + '" cy="' + (by - 5) + '" r="6" fill="#F7D774"/>';
    s += '<ellipse cx="' + (fx0 + w / 2 + d / 2) + '" cy="' + (fy0 - d / 2 + 2) + '" rx="' + (w / 2.4) + '" ry="5" fill="#fff" opacity=".85"/>';
    return s + '<defs><linearGradient id="lgbRib" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#B8862B"/><stop offset=".5" stop-color="#FBE08A"/><stop offset="1" stop-color="#B8862B"/></linearGradient></defs></svg>';
  }
  var deco = document.createElement('div');
  deco.className = 'lgban-deco';
  deco.innerHTML =
    branch(false) + branch(true) +
    star('lgban-star--1') + star('lgban-star--2') + star('lgban-star--3') + star('lgban-star--4') + star('lgban-star--5') +
    twinkle('lgban-tw--1') + twinkle('lgban-tw--2') + twinkle('lgban-tw--3') + twinkle('lgban-tw--4') + twinkle('lgban-tw--5') + twinkle('lgban-tw--6') +
    '<div class="lgban-gifts lgban-gifts--l">' + gift(96, 78, 26, '#C8102E', '#8E0B1F', '#E2353F', '#E9B949') + gift(70, 58, 20, '#1E6B47', '#13472F', '#2F8A5D', '#C8102E') + '</div>' +
    '<div class="lgban-gifts lgban-gifts--r">' + gift(84, 92, 24, '#F4F1EA', '#D9D2C3', '#FFFFFF', '#C8102E') + gift(104, 70, 28, '#C8102E', '#8E0B1F', '#E2353F', '#E9B949') + '</div>';
  fx.insertBefore(deco, fx.querySelector('.lgban-ground').nextSibling);
  var cv = fx.querySelector('canvas'), ctx = cv.getContext('2d');
  var W = 0, H = 0, dpr = 1, flakes = [], on = true, raf = 0, last = 0;
  function make(n) {
    flakes = [];
    for (var k = 0; k < n; k++) {
      var near = Math.random() < 0.12;
      flakes.push({
        x: Math.random() * W, y: Math.random() * H,
        r: near ? 4 + Math.random() * 2.4 : 1.4 + Math.random() * 1.9,
        a: near ? 0.55 + Math.random() * 0.25 : 0.65 + Math.random() * 0.35,
        v: near ? 30 + Math.random() * 10 : 16 + Math.random() * 16,
        s: Math.random() * Math.PI * 2, w: 0.4 + Math.random() * 0.8, near: near
      });
    }
  }
  function size() {
    var r = hero.getBoundingClientRect();
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = r.width; H = r.height;
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    cv.style.width = W + 'px'; cv.style.height = H + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    make(W < 750 ? 22 : 45);
  }
  function draw() {
    ctx.clearRect(0, 0, W, H);
    for (var k = 0; k < flakes.length; k++) {
      var f = flakes[k];
      ctx.globalAlpha = f.a;
      ctx.fillStyle = '#ffffff';
      ctx.shadowColor = 'rgba(52, 104, 168, .38)'; ctx.shadowBlur = f.near ? 8 : 3;
      ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.2832); ctx.fill();
    }
    ctx.globalAlpha = 1; ctx.shadowBlur = 0;
  }
  function tick(t) {
    raf = 0;
    if (!on) return;
    var dt = last ? Math.min((t - last) / 1000, 0.05) : 0.016; last = t;
    for (var k = 0; k < flakes.length; k++) {
      var f = flakes[k];
      f.s += dt * f.w; f.y += f.v * dt; f.x += Math.sin(f.s) * 12 * dt + 4 * dt;
      if (f.y > H + 6) { f.y = -6; f.x = Math.random() * W; }
      if (f.x > W + 6) f.x = -6;
    }
    draw();
    raf = requestAnimationFrame(tick);
  }
  function start() { if (RM || raf || !on) return; last = 0; raf = requestAnimationFrame(tick); }
  function stop() { if (raf) cancelAnimationFrame(raf); raf = 0; }
  size(); draw();
  if (!RM) {
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { on = e[0].isIntersecting && !document.hidden; on ? start() : stop(); }).observe(hero);
    document.addEventListener('visibilitychange', function () { on = !document.hidden; on ? start() : stop(); });
    start();
  }
  if ('ResizeObserver' in window) new ResizeObserver(function () { var r = hero.getBoundingClientRect(); if (Math.abs(r.height - H) > 24 || Math.abs(r.width - W) > 2) { size(); draw(); } }).observe(hero);
  var rw = innerWidth;
  addEventListener('resize', function () { if (Math.abs(innerWidth - rw) < 2) return; rw = innerWidth; size(); draw(); }, { passive: true });
})();
